import { useOptimizelyFeatureFlag } from '@shared/v2/contexts/optimizely';

export const usePackagePageV3 = () => {
  const [decision] = useOptimizelyFeatureFlag(
    'qantas-holidays-package-page-v3',
  );
  return decision?.enabled || false;
};
